import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
export const VersionListSectionHeader = /*#__PURE__*/ memo((param)=>{
    let { title, buttons } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "mb-2 flex w-full items-center justify-between",
        children: [
            /*#__PURE__*/ _jsx("h4", {
                className: "text-left text-10 font-bold uppercase text-grey-12",
                children: title
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex items-center gap-2",
                children: buttons
            })
        ]
    });
});
VersionListSectionHeader.displayName = "VersionListSectionHeader";
